import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { AllRawData } from '../../raw-types.ts';

// 웨이브샵 config 정규화 컬렉션. stage/league/valhalla/degen wave 는 inline shop
// 대신 shopConfigId 만 저장하고, 서버가 이 컬렉션으로 shop 을 복원한다.
export const WaveShopConfigSchema = defineSchema({
  name: 'serverWaveShopConfigs',
  fields: [
    ['id', 'number'],
    ['itemCount', 'number'],
    ['itemGroups', { kind: 'array', of: 'stageWaveShopItemGroup' }],
  ],
  lookupKeys: ['id'],
});

export interface RawWaveShopConfigRow {
  id: number;
  item_count: number;
}

export function waveShopConfigFromRaw(
  row: RawWaveShopConfigRow,
  raw: Pick<AllRawData, 'item_group'>
) {
  return {
    id: row.id,
    itemCount: row.item_count,
    itemGroups: (raw.item_group ?? [])
      .filter((g) => g.wave_shop_config_id === row.id)
      .map((g) => ({
        itemId: g.item_id,
        silverPriceMin: g.silver_price_min,
        silverPriceMax: g.silver_price_max,
        weight: g.weight,
      })),
  };
}

registerCategorySchema('serverWaveShopConfigs', WaveShopConfigSchema);
